// @ts-nocheck
import React from 'react';
import { NavLink } from 'react-router-dom';
import { hasPermission } from '../../auth/authUtils';
import permissionTypes from '../../../constants/permissionTypes';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../hooks';

function PackageTypeLink({ id, name }) {
  const { t } = useTranslation();
  const currentUser = useAppSelector((state) => state.auth);
  return (
    <>
      {id && name ? (
        hasPermission(currentUser, permissionTypes.MANAGE_SETTINGS) ? (
          <NavLink
            to={`/settings/package-type/${id}`}
            title={t('View package type')}
          >
            {name}
          </NavLink>
        ) : (
          name
        )
      ) : name ? (
        name
      ) : (
        '-'
      )}
    </>
  );
}

export default PackageTypeLink;
